import { render, staticRenderFns } from "./teamHome.vue?vue&type=template&id=42276a8c&scoped=true&lang=pug&"
import script from "./teamHome.vue?vue&type=script&lang=js&"
export * from "./teamHome.vue?vue&type=script&lang=js&"
import style0 from "./teamHome.vue?vue&type=style&index=0&id=42276a8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42276a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42276a8c', component.options)
    } else {
      api.reload('42276a8c', component.options)
    }
    module.hot.accept("./teamHome.vue?vue&type=template&id=42276a8c&scoped=true&lang=pug&", function () {
      api.rerender('42276a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/team_home/teamHome.vue"
export default component.exports